import React from "react";
import { motion } from "framer-motion";
import { projectsData } from "../../data";

const Projects = () => {
  return (
    <div className="h-screen relative overflow-hidden flex flex-col text-left md:flex-row  justify-center mx-auto items-center z-0 max-w-full ">
      <h3 className="absolute top-24 uppercase tracking-[20px] text-gray-500 text-2xl cursor-default ">
        Projects
      </h3>
      {/* projects */}

      <motion.div
        initial={{
          y: 200,
        }}
        whileInView={{
          y: 0,
        }}
        transition={{
          type: "spring",
          duration: 2,
        }}
        className="relative w-full flex overflow-y-scroll overflow-y-hidden snap-x snap-mandatory z-20 scrollbar-thin scrollbar-thumb-[#F7AB0A]/80 scrollbar-track-gray-500  scrollbar-thumb-rounded-full scrollbar-track-rounded-full "
      >
        {projectsData.map((item, index) => {
          return (
            <div
              className="w-screen flex-shrink-0 snap-center flex flex-col space-y-5 items-center justify-center sm:justify-center pt-20 md:pt-10 h-screen z-20 "
              key={index}
            >
              <img
                src={item.projectImage}
                alt=""
                className="w-60 hover:scale-110 transition-all ease-in-out hover:drop-shadow-2xl"
                width={200}
                height={200}
              />
              <div className="flex items-center space-x-4 font-bold">
                <span className="underline decoration-[#67B7D1]/40">
                  <a href={item.githubLink} target="_blank" rel="noreferrer">
                    Github Link
                  </a>
                </span>
                <span className="underline decoration-[#67B7D1]/40">
                  <a href={item.liveLink} target="_blank" rel="noreferrer">
                    Live Link
                  </a>
                </span>
              </div>
              <div className="space-y-10 px-4 md:px-10 max-w-3xl text-center">
                <h4 className="text-4xl font-semibold tracking-wide flex flex-col cursor-default text-[#F7AB0A]/70">
                  Project {index + 1} of {projectsData.length} :{" "}
                  {item.projectName}
                </h4>
                <p className="text-lg text-justify cursor-default">
                  {item.projectDesc}
                </p>
              </div>
            </div>
          );
        })}
      </motion.div>
    </div>
  );
};

export default Projects;
